import Validator from '../validator'

class ValidatorsManager {
	constructor(elField) {
		this._init(elField)
	}
	_init(elField) {
		this.elField = elField
		if(!this.elField) {
			return
		}
		this.validators = []
		this.elInfo = this.elField.querySelector('[data-field-info]')
		this.elInputs = Array.from(this.elField.querySelectorAll('[data-validator]'))
		this.elInputs.forEach(el =>  {
			el.input = new Input(el, this)
			el.addEventListener('input', () => this.onAfterErrorInput())
		})
	}
	validateAll()
	{
		let isValid
		this.validators.forEach(v => {
			const newValid = v.validate()
			if(v.type === "radio" || v.type === "radio-field") {
				isValid = isValid || newValid
				if(!isValid) {
					this.getField().displayError(v.error)
				}
			} else {
				isValid = typeof isValid === "boolean" ? isValid : true
				if(isValid && !newValid) {
					this.getField().displayError(v.error)
					isValid = false
				}
			}
		})
		if(isValid) {
			this.getField().clearError()
		}
		return typeof isValid === "boolean" ? isValid : true
	}
	getField() {
		return this.elField.field
	}
	getValue() {
		let value = ""
		this.elInputs.forEach(el => {
			const newValue = el.input.getValue()
			value += newValue + " "
		})
		return value
	}
	onAfterErrorInput() {
		if(!this.getField().isDisplayingError) {
			return
		}
		this.getField().clearError()
	}
}

class Input {
	constructor(el, manager) {
		this._init(el, manager)
	}
	_init(el, manager) {
		this.el = el
		this.manager = manager
		const types= this.el.getAttribute('data-validator')
		this.validatorTypes = types.split(' ')
		if(this.validatorTypes) {
		   this.validatorTypes.forEach(type => this.manager.validators.push(new Validator(this.el, type, this.manager.elInfo)))
		}
	}
	getValue() {
		let value = ""
		if(this.validatorTypes.includes("radio") || this.validatorTypes.includes("radio-field")) {
			if(this.el.checked) {
				const index = this.getIndexfOfSelf()
				value += Math.floor(index / 2)
			}
		} else {
			value = "" + (this.el.value || this.el.innerText)
		}
		return value
	}
	getIndexfOfSelf() {
		return Array.prototype.indexOf.call(this.el.parentNode.children, this.el)
	}
}

export default ValidatorsManager